import api from './Api';
import { Deposit, DepositProduct } from '../types/Product';

export const DepositApi = {
  // Get all deposits (filtered by user, except for admin)
  getDeposits: () => api.get<Deposit[]>('/deposits'),
  
  // Get ALL deposits (admin only - for management purposes)
  getAllDepositsForAdmin: () => api.get<Deposit[]>('/deposits/admin/all'),
  
  // Get deposit by ID
  getDeposit: (id: number) => api.get<Deposit>(`/deposits/${id}`),
  
  // Create new deposit
  createDeposit: (deposit: Partial<Deposit>) => api.post<Deposit>('/deposits/create', deposit),
  
  // Update deposit
  updateDeposit: (id: number, deposit: Partial<Deposit>) => api.put<Deposit>(`/deposits/${id}`, deposit),
  
  // Delete deposit
  deleteDeposit: (id: number) => api.delete(`/deposits/${id}`),
  
  // Get all products in a deposit
  getDepositProducts: (depositId: number) => api.get<DepositProduct[]>(`/deposit-products/by-deposit/${depositId}`, {
    headers: { 'Cache-Control': 'no-cache' }
  }),
  
  // Add or increase product quantity in deposit
  addProductToDeposit: (depositId: number, productId: number, quantity: number) => 
    api.post<DepositProduct>('/deposit-products/add', null, {
      params: { depositId, productId, quantity }
    }),
  
  // Decrease product quantity in deposit
  decreaseProductFromDeposit: (depositId: number, productId: number, quantity: number) => 
    api.post<DepositProduct>('/deposit-products/decrease', null, {
      params: { depositId, productId, quantity }
    }),
  
  // Set product quantity in deposit
  setProductQuantityInDeposit: (depositId: number, productId: number, quantity: number) => 
    api.post<DepositProduct>('/deposit-products/set', null, {
      params: { depositId, productId, quantity }
    }),
  
  // Get all deposit products across all deposits
  getAllDepositProducts: () => api.get<DepositProduct[]>('/deposit-products', {
    headers: { 'Cache-Control': 'no-cache' }
  }),
  
  // Get product inventory across all deposits
  getProductInventory: (productId: number) => api.get<DepositProduct[]>(`/products/${productId}/inventory`),
  
  // Get deposits by user ID
  getDepositsByUser: (userId: number) => api.get<Deposit[]>(`/deposits/by-user/${userId}`),

  // Assign a user to a deposit (admin/warehouse)
  assignUserToDeposit: (depositId: number, userId: number) =>
    api.post(`/deposits/${depositId}/assign-user`, null, { params: { userId } }),

  // Remove a user from a deposit (admin/warehouse)
  removeUserFromDeposit: (depositId: number, userId: number) =>
    api.post(`/deposits/${depositId}/remove-user`, null, { params: { userId } }),

  // Actualize inventory - update all quantities based on actual counts
  actualizeInventory: (depositId: number, actualizedProducts: Array<{productId: number, quantity: number}>) =>
    api.post(`/deposit-products/actualize`, actualizedProducts, { params: { depositId } }),
};
